import { env } from '../../lib/env/env';

export const dataDogRUMConfig = {
  CAPFIN_RUM_APP_ID: env.getString('CAPFIN_RUM_APP_ID') || '',
  CAPFIN_RUM_CLIENT_TOKEN: env.getString('CAPFIN_RUM_CLIENT_TOKEN') || '',
  CAPFIN_APP_ENV: env.getString('REACT_APP_ENV') || 'localhost',
  CAPFIN_APP_VERSION: env.getString('REACT_APP_COMMIT_REF') || '0.0.1',
};
